import { SelectOption } from "components/common/FormDialog/types";
import { PoolerMode } from "./types";

export const DATABASE_METRIC_DEFAULT_RANGE = 60; // in minutes
export const DATABASE_METRIC_DEFAULT_DURATION = 30; // in seconds

// Mirror gotham-golem validation.go and RequestCreate.
export const DATABASE_REGEX = {
  // Instance name and its first user on create: the API caps both at 16 characters.
  NAME: /^[A-Za-z0-9-]{0,15}[A-Za-z0-9]$/,
  CHILD_NAME: /^[A-Za-z_][A-Za-z0-9_-]{0,62}$/,
  // Also names the user's Secret: no "_".
  USER_NAME: /^[A-Za-z]([A-Za-z0-9-]{0,30}[A-Za-z0-9])?$/,
  // IPv4 with a prefix length, the one form the API accepts (validIPv4CIDR).
  IP_CIDR:
    /^((0|[1-9][0-9]?|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}(0|[1-9][0-9]?|1[0-9]{2}|2[0-4][0-9]|25[0-5])\/(0|[1-9]|[12][0-9]|3[0-2])$/
};

export const DATABASE_ERROR_MESSAGES = {
  NAME: "Name must contain only Latin letters (a-z, A-Z), digits (0-9), hyphen (-), must not end with a hyphen and must be at most 16 characters long.",
  CHILD_NAME:
    "Name must contain only Latin letters (a-z, A-Z), digits (0-9), hyphen (-), underscore (_), must not start with a digit or hyphen and must be at most 63 characters long.",
  USER_NAME:
    "Name must start with a Latin letter, contain only Latin letters (a-z, A-Z), digits (0-9) and hyphen (-), must not end with a hyphen and must be at most 32 characters long.",
  IP_ACL:
    'Each entry must be an IPv4 address with a prefix length (e.g., "192.168.1.101/32"), one per line.',
  PARAMETER_VALUE:
    "Value must not contain spaces, quotes or control characters.",
  RESERVED_NAME: "This database name is reserved. Choose a different name.",
  RESERVED_USER: "This user name is reserved. Choose a different name."
};

export const RESERVED_DATABASE_USERS = [
  "root",
  "postgres",
  "admin",
  "default",
  "replication",
  "replicator",
  "healthcheck"
];

export const RESERVED_DATABASE_NAMES = [
  "postgres",
  "template0",
  "template1",
  "mysql",
  "information_schema",
  "performance_schema",
  "sys",
  "admin",
  "local",
  "config"
];

export const BACKUP_FILE_NOTES = {
  UNATTRIBUTED:
    "Not attributed to this database: its name carries no instance and the bucket is shared",
  OLDER_LAYOUT:
    "Older layout: restores into the database you pick, it does not recreate the source database"
};

export const POOLER_MODE_OPTIONS: SelectOption[] = [
  { value: "transaction", label: "Transaction" },
  { value: "session", label: "Session" }
];

export const POOLER_MODE_DESCRIPTIONS: Record<PoolerMode, string> = {
  transaction:
    "Clients keep their connection through a switchover or failover. Session state (SET, advisory locks, LISTEN, temporary tables) does not outlive a transaction.",
  session:
    "Full session semantics; connections are pooled but drop on a switchover."
};

export const POOLER_DISCONNECT_WARNING =
  "All clients connected through the pooler (port 6432) will be disconnected.";
